module.exports = __webpack_public_path__ + "static/img/survival-working-tips.e66ef945.svg";